import styled from 'styled-components';
import { Card, Button } from 'antd';
import { COLORS, TYPOGRAPHY_SIZES } from '../../../../theme';

export const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

export const ControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  background-color: #f5f5f5;
  border-radius: 6px;
  padding: 4px;
  margin-bottom: 8px;
  width: 100%;
`;

export const ZoomDisplay = styled.span`
  font-size: 13px;
  color: #595959;
  padding: 0 12px;
  white-space: nowrap;
  font-weight: 500;
  min-width: 80px;
  text-align: center;
`;

export const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  height: 600px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    height: auto;
  }
`;

export const ImageCard = styled(Card)`
  position: relative;
  overflow: hidden;
  background-color: ${COLORS.lightDark};
  border: 1px solid #333;
  height: 100%;
  display: flex;
  flex-direction: column;

  .ant-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0;
    position: relative;
    overflow: hidden;
  }
`;

export const ImageLabel = styled.div`
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.7);
  color: ${COLORS.white};
  padding: 4px 12px;
  border-radius: 4px;
  font-size: ${TYPOGRAPHY_SIZES.SMALL};
  font-weight: 500;
  pointer-events: none;
`;

export const SegmentationOverlay = styled.img<{ $transform: string; $overlayColor: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 1;
  z-index: 2;
  pointer-events: none;
  transform: ${props => props.$transform};
  transform-origin: center center;
  filter: ${props =>
    props.$overlayColor === 'green'
      ? 'hue-rotate(90deg) saturate(1.5) drop-shadow(0 0 3px yellow) drop-shadow(0 0 3px yellow)'
      : 'hue-rotate(0deg) saturate(1.5) drop-shadow(0 0 3px yellow) drop-shadow(0 0 3px yellow)'};
`;

export const ToggleControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 12px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  flex-wrap: wrap;
`;

export const ToggleLabel = styled.span`
  font-size: ${TYPOGRAPHY_SIZES.SMALL};
  font-weight: 500;
  color: #666;
  margin-right: 8px;
`;

export const ToggleButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

export const ImageContainer = styled.div`
  flex: 1;
  overflow: hidden;
  cursor: move;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const StyledImage = styled.img<{ $transform?: string }>`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  ${props => (props.$transform ? `transform: ${props.$transform};` : '')}
  transform-origin: center center;
  user-select: none;
  -webkit-user-drag: none;
`;

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: transparent;
  color: #595959;
  transition: all 0.2s;

  &:hover {
    background-color: #e6e6e6;
    color: #262626;
  }

  &:active {
    background-color: #d9d9d9;
  }

  &.ant-btn:hover,
  &.ant-btn:focus {
    background-color: #e6e6e6;
    color: #262626;
    border-color: transparent;
  }

  .anticon {
    font-size: 16px;
  }
`;

export const TransformLayer = styled.div<{ $transform: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${props => props.$transform};
  transform-origin: center center;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
`;
